import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DEVICE_APPLICATION_STATE_FEATURE_KEY } from './device-application-state.state';
import { deviceApplicationStateReducer } from './device-application-state.reducer';
import { DeviceApplicationStateEffects } from './device-application-state.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(DEVICE_APPLICATION_STATE_FEATURE_KEY, deviceApplicationStateReducer),
    EffectsModule.forFeature([DeviceApplicationStateEffects]),
  ],
})
export class DeviceApplicationStateStoreModule {}
